import { render, staticRenderFns } from "./FormPeriodicidade.vue?vue&type=template&id=16ed8aa4&scoped=true"
import script from "./FormPeriodicidade.vue?vue&type=script&lang=js"
export * from "./FormPeriodicidade.vue?vue&type=script&lang=js"
import style0 from "./FormPeriodicidade.vue?vue&type=style&index=0&id=16ed8aa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed8aa4",
  null
  
)

export default component.exports